module.exports = __webpack_public_path__ + "icon-account.svg?11bcf34042bc040eb563f692ee61088c";